export default __webpack_public_path__ + "static/media/learn_button_save.ffbbd4c7.png";